(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fnps-contact"] && !Shopify.designMode) return;
  try {
    
  function hsCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function hsFieldValue(form, selector) {
    var el = form.querySelector(selector);
    return el && el.value ? el.value.trim() : '';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('fnps-contact__form')) return;

    var portal = form.getAttribute('data-hs-portal');
    var formId = form.getAttribute('data-hs-form');
    if (!portal || !formId) return;

    var region = form.getAttribute('data-hs-region') || 'na1';
    var subject = hsFieldValue(form, '[name="contact[Subject]"]');
    var message = hsFieldValue(form, '[name="contact[Comment]"]');
    var combined = subject ? '[' + subject + '] ' + message : message;

    var fields = [];
    function push(prop, value) {
      if (prop && value) fields.push({ name: prop, value: value });
    }
    push(form.getAttribute('data-hs-prop-email'), hsFieldValue(form, '[name="contact[email]"]'));
    push(form.getAttribute('data-hs-prop-name'), hsFieldValue(form, '[name="contact[Name]"]'));
    push(form.getAttribute('data-hs-prop-phone'), hsFieldValue(form, '[name="contact[Phone number]"]'));
    push(form.getAttribute('data-hs-prop-combined'), combined);

    if (!fields.length) return;

    var payload = {
      fields: fields,
      context: {
        pageUri: window.location.href,
        pageName: document.title
      }
    };

    var hutk = hsCookie('hubspotutk');
    if (hutk) payload.context.hutk = hutk;

    var endpoint = 'https://api.hsforms.com/submissions/v3/integration/submit/' + portal + '/' + formId;
    if (region && region !== 'na1') {
      endpoint = 'https://api-' + region + '.hsforms.com/submissions/v3/integration/submit/' + portal + '/' + formId;
    }

    try {
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
        mode: 'cors'
      }).catch(function () {});
    } catch (e) {
      /* never block the Shopify submission */
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnps-header"]) return;
  try {
    
  function closeNavDropdowns(except) {
    document.querySelectorAll('.fnps-nav-dropdown[open]').forEach(function (item) {
      if (item !== except) item.removeAttribute('open');
    });
  }

  function initNavHover() {
    document.querySelectorAll('.fnps-nav-dropdown').forEach(function (dropdown) {
      dropdown.addEventListener('mouseenter', function () {
        if (window.innerWidth >= 900) {
          closeNavDropdowns(dropdown);
          dropdown.setAttribute('open', '');
        }
      });
      dropdown.addEventListener('mouseleave', function () {
        if (window.innerWidth >= 900) {
          dropdown.removeAttribute('open');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavHover);
  } else {
    initNavHover();
  }

  document.addEventListener('click', function (event) {
    var dropdown = event.target.closest('.fnps-nav-dropdown');
    closeNavDropdowns(dropdown);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeNavDropdowns(null);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
